import React from 'react';
import {
  calculateSumOfEachRow,
  deleteRowHandler,
  myCustomCelEditFunction,
  updateTableCellHandler
} from "../SellFactor/SellFactorFunctions";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import NewTabulator from "../NewTabulator/NewTabulator";
import numeric from "../../utils/NumericFunction";
import {parseToEnRemoveComma} from "../../utils/CommaSeparator";

const TransferBetweenStoresTable = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {

  const tableColumns = [{
    title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
    maxWidth: 100, headerHozAlign: "center",
    style: {width: '300px', overflow: 'hidden'},
    cellClick: function (e, cell) {
      const productId = cell.getData().productId;
      const storeId = cell.getData().storeId;
      const tableData = deleteRowHandler(sendData.tableData, productId, storeId);
      setSendData({tableData})

    }
  },
    {field: "seriesId", visible: false,},
    {field: "recordId", visible: false,},
    {title: "کد انبار", field: "storeId", visible: true,},
    {title: "مبدا", field: "storeName", visible: true,},
    {title: "کد کالا", field: 'productId', visible: true,},
    {title: "نام کالا", field: 'productName',},
    {title: "کد انبار مقصد", field: "destinationStoreId", visible: false,},
    {title: "مقصد", field: "destinationStoreName", visible: true,},
    {title: "گروه کالا", field: 'productGroup',},
    {title: "رنگ", field: 'productColor',},
    {title: "سایز", field: 'productSize',},
    {
      title: "تعداد", field: 'number', sorter: "number", editor: "number", formatter: tableCalc.separateNumbers,
      // cellEdited: function (cell) {
      //   const newData = {...cell.getRow().getData()};
      //   newData.number = cell.getValue();
      //
      // },

      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        console.log(value)
        // myCustomCelEditFunction(sendData, setSendData, cell, "number", e.target.value)
        // setReload(!reload)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;

        const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, "number", value)
        setSendData({tableData})
      },

      bottomCalc: tableCalc.sum,
      style: {textAlign:'center'}

    },

  ];

  // const celEditHandler = cell => {
  //
  //   console.log(sendData.tableData)
  //   // calculateSumOfEachRow(sendData.tableData)
  //   setSendData({tableData: calculateSumOfEachRow(sendData.tableData)})
  // }

  console.log("Render Transfer")

  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >
      <NewTabulator
        columns={tableColumns}
        data={[...sendData.tableData]}
        style={{height: "70vh", overflow: 'scroll'}}
        className={"header__color__F1F1F1"}

      />

      {/*<ReactTabulator*/}
      {/*  columns={tableColumns}*/}
      {/*  data={sendData.tableData}*/}
      {/*  options={tabulatorTableOptions.tableOptions}*/}
      {/*  style={{height: "70vh"}}*/}
      {/*/>*/}

    </div>
  );
};

export default TransferBetweenStoresTable;
